import { MenuItem, Select } from "@mui/material";
import React, { useEffect, useState } from "react";
import PropTypes from 'prop-types';
const Vessel = ({ vesselData, getData, setVesselId, setCabinCategoryId }) => {
  const [selectedValue, setSelectedValue] = useState("");
  useEffect(() => {
    getData(1);
  }, [selectedValue]);
  return (
    <Select
      style={{ width: "15%", height: "40px", marginRight:"10px" }}
      required
      displayEmpty
      renderValue={selectedValue !== "" ? undefined : () => "Select Vessel"}
      value={selectedValue}
      onChange={(e) => {
        setVesselId(e.target.value);
        setSelectedValue(e.target.value);
        setCabinCategoryId("");
      }}
    >
      {vesselData?.map((item, index) => (
        <MenuItem key={index+""} value={item.id}>
          {item.name}
        </MenuItem>
      ))}
    </Select>
  );
};

// Vessel.propTypes = {
//   vesselData: PropTypes.any,
//   getData: PropTypes.any,
//   setVesselId: PropTypes.any,
//   setCabinCategoryId: PropTypes.any,
// };
export default Vessel;
